import axios from "axios";

function OrderService() {
  const PostOrder = async (formState) => {
    let protocol = "";
    if (window.location.protocol === "https:") {
      protocol = "https";
    } else {
      protocol = "http";
    }
    // `${protocol}://nepaliau.khojira.com/api/vegtiffinorder/post`,
    const post = await axios.post(
      `${protocol}://nepaliau.khojira.com/api/vegtiffinorder/post`,
      formState
    );
    return post;
  };

  return { PostOrder };
}

export default OrderService;
